import {clsx} from 'clsx'
import {useRef} from 'react'

import {useInlineCommentDialogModeInteractiveElements} from '../../hooks/use-inline-comment-dialog-mode-interactive-elements'
import {Annotation} from './Annotation'
import styles from './InlineAnnotation.module.css'
import {useDialogModeIsEnabled} from '../../stores/selectors'
import type {DiffAnnotation} from '../../conversation-types'

interface InlineAnnotationProps {
  annotation: DiffAnnotation
  gridCellId: string
  isFirstMarker?: boolean
}

/**
 * Inline wrapper for the Annotation component
 * Used within inline markers to display annotations in the context of code
 */
export function InlineAnnotation({annotation, gridCellId, isFirstMarker}: InlineAnnotationProps) {
  const annotationRef = useRef<HTMLDivElement>(null)
  const isInDialogMode = useDialogModeIsEnabled(gridCellId)

  useInlineCommentDialogModeInteractiveElements({
    commentSubjectType: 'pull request',
    gridCellId,
    markerRef: annotationRef,
  })

  return (
    <div
      id={`annotation_${annotation.databaseId}`}
      ref={annotationRef}
      className={clsx(
        'border rounded-2 color-border-default color-shadow-small overflow-hidden',
        isFirstMarker ? 'mb-1' : 'mb-2',
        styles.inlineAnnotation,
      )}
      data-level={annotation.annotationLevel}
      data-testid={`annotation-${annotation.id}`}
      data-marker-id={`${annotation.id}`}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isInDialogMode ? 0 : -1}
    >
      <Annotation annotation={annotation} />
    </div>
  )
}

try{ InlineAnnotation.displayName ||= 'InlineAnnotation' } catch {}